var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Container = PIXI.Container;
var Point = PIXI.Point;
import { OutlineFilter } from "@pixi/filter-outline";
import { merge } from "rxjs";
import { IdOrientation } from "../../../constants/IdOrientation";
import { eventsCanvas } from "../../../events/eventsCanvas";
import { IdCursor } from "../../../events/IdCursor";
import { BF2GetCheckCallouts } from "../../../graphics/outskirts/BF2GetCheckCallouts";
import { utilGrid } from "../../../utils/grid/utilGrid";
import { warnGraphics } from "../../../utils/logging/logging";
import { utilBuildings } from "../../../utils/utilBuildings";
import { SceneLayer } from "../../scenes/SceneLayer";
import { TypeBuildingAction } from "../buildings/reducerBuildings";
var LayerPlayerBaseSurrounding = /** @class */ (function (_super) {
    __extends(LayerPlayerBaseSurrounding, _super);
    function LayerPlayerBaseSurrounding() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.graphicsByExpansionPartId = new Map();
        _this.expansionGroups = [];
        _this.shouldUpdate = function (state, previousState) {
            if (state.expansionInfo == undefined ||
                state.expansionInfo.unlockedExpansionIds == undefined ||
                state.fence == undefined) {
                return false;
            }
            if (!previousState || !previousState.fence) {
                return true;
            }
            var expansionIdsChanged = previousState.expansionInfo.unlockedExpansionIds !==
                state.expansionInfo.unlockedExpansionIds;
            var assetLoadStateChanged = previousState.areAssetsLoaded !== state.areAssetsLoaded;
            var fenceUpgraded = previousState.fence.proto.stage !== state.fence.proto.stage;
            var isFinishedScaffolding = utilBuildings.hasFinishedConstruction(state.fence);
            return (expansionIdsChanged || assetLoadStateChanged || fenceUpgraded || isFinishedScaffolding);
        };
        _this.update = function (props) {
            var areAssetsLoaded = props.areAssetsLoaded;
            var unlockedExpansionIds = props.expansionInfo.unlockedExpansionIds;
            if (!unlockedExpansionIds || !areAssetsLoaded) {
                return;
            }
            _this.cleanup();
            _this.createExpansionParts();
            _this.createExpansionGroups();
            _this.postUpdate();
        };
        _this.postUpdate = function () {
            // Overridden in descendant classes
        };
        _this.createExpansionParts = function () {
            var _a = _this.props, _b = _a.expansionInfo, baseSetup = _b.baseSetup, unlockedExpansionIds = _b.unlockedExpansionIds, fence = _a.fence;
            if (!unlockedExpansionIds) {
                return;
            }
            _this.allExpansionIds.forEach(function (id) {
                var neighbours = utilGrid.getExpansionNeighboursNamed(id, baseSetup);
                var posOnMap = utilGrid.expansionIdToXY(id, baseSetup);
                // This is kind of a hack to send the graphics function expansion position
                fence.proto.posX = posOnMap.x;
                fence.proto.posY = posOnMap.y;
                if (unlockedExpansionIds.indexOf(id) === -1) {
                    _this.addCornerPillars(neighbours, _this.lockedExpansionNeedsFence);
                }
                else {
                    _this.addPiecesAndSmallPillars(neighbours);
                    _this.addCornerPillars(neighbours, _this.unlockedExpansionNeedsFence);
                }
            });
        };
        _this.createExpansionGroups = function () {
            var _a = _this.props, baseSetup = _a.expansionInfo.baseSetup, fence = _a.fence;
            var clicks$ = [];
            var mouseOver$ = [];
            var mouseOut$ = [];
            _this.graphicsByExpansionPartId.forEach(function (graphics, key) {
                var id = _this.getExpansionPartInfoById(key).id;
                var posOnScreen = utilGrid.getExpansionPosition(id, baseSetup);
                // Optimization to not have containers if not needed
                if (graphics.length === 1) {
                    var display = graphics[0];
                    var position = display.position;
                    position.set(position.x + posOnScreen.x, position.y + posOnScreen.y);
                    display.name = key;
                    _this.expansionGroups.push(display);
                    _this.addChild(display);
                    if (display.hitArea != undefined) {
                        display.interactive = true;
                        display.cursor = IdCursor.Pointer;
                        clicks$.push(eventsCanvas.createClick$(display));
                        mouseOver$.push(eventsCanvas.createMouseOver$(display));
                        mouseOut$.push(eventsCanvas.createMouseOut$(display));
                    }
                    return;
                }
                var container = new Container();
                container.name = key;
                container.interactiveChildren = false;
                container.position.set(posOnScreen.x, posOnScreen.y);
                container.cursor = IdCursor.Pointer;
                _this.expansionGroups.push(container);
                _this.addChild(container);
                graphics.forEach(function (display) {
                    if (display.hitArea != undefined && display.hitArea.hasOwnProperty("points")) {
                        if (container.hitArea != undefined) {
                            warnGraphics("Fence: overwriting hitArea for \"" + container.name + "\". This might be caused because of both fence piece and pillar having colliders set.");
                        }
                        container.interactive = true;
                        container.interactiveChildren = true;
                        if (utilBuildings.hasFinishedConstruction(fence)) {
                            var callout = BF2GetCheckCallouts();
                            if (callout) {
                                callout.name = "Fence_Callout";
                                callout.position.set(200, -230);
                                container.addChild(callout);
                            }
                        }
                        clicks$.push(eventsCanvas.createClick$(container));
                        mouseOver$.push(eventsCanvas.createMouseOver$(container));
                        mouseOut$.push(eventsCanvas.createMouseOut$(container));
                    }
                    container.addChild(display);
                });
            });
            _this.clickSub$ = merge.apply(void 0, clicks$).subscribe(_this.onClick);
            _this.mouseOverSub$ = merge.apply(void 0, mouseOver$).subscribe(_this.addHighlight);
            _this.mouseOutSub$ = merge.apply(void 0, mouseOut$).subscribe(_this.removeHighlight);
        };
        _this.cleanup = function () {
            var baseSetup = _this.props.expansionInfo.baseSetup;
            if (!_this.allExpansionIds) {
                var count = baseSetup.expansionsX * baseSetup.expansionsY;
                _this.allExpansionIds = new Array(count).fill(1).map(function (_, i) { return i; });
            }
            _this.expansionGroups = [];
            _this.graphicsByExpansionPartId.clear();
            _this.removeChildren();
            if (_this.clickSub$) {
                _this.clickSub$.unsubscribe();
            }
            if (_this.mouseOutSub$) {
                _this.mouseOutSub$.unsubscribe();
            }
            if (_this.mouseOverSub$) {
                _this.mouseOverSub$.unsubscribe();
            }
        };
        _this.addPiecesAndSmallPillars = function (neighbours) {
            var _a = _this.props, getPieceIso = _a.getPieceIso, getPillarIso = _a.getPillarIso, baseSetup = _a.expansionInfo.baseSetup;
            var up = neighbours.up, down = neighbours.down, left = neighbours.left, right = neighbours.right;
            if (_this.unlockedExpansionNeedsFence(up)) {
                _this.addGraphic(getPieceIso, IdOrientation.Up);
                if (!_this.unlockedExpansionNeedsFence(right)) {
                    var nUp = utilGrid.getExpansionNeighboursNamed(right, baseSetup).up;
                    if (_this.unlockedExpansionNeedsFence(nUp)) {
                        _this.addGraphic(getPillarIso, IdOrientation.Up);
                    }
                }
            }
            if (_this.unlockedExpansionNeedsFence(right)) {
                _this.addGraphic(getPieceIso, IdOrientation.Right);
                if (!_this.unlockedExpansionNeedsFence(up)) {
                    var nRight = utilGrid.getExpansionNeighboursNamed(up, baseSetup).right;
                    if (_this.unlockedExpansionNeedsFence(nRight)) {
                        _this.addGraphic(getPillarIso, IdOrientation.Right);
                    }
                }
            }
            if (_this.unlockedExpansionNeedsFence(left)) {
                _this.addGraphic(getPieceIso, IdOrientation.Left);
                if (!_this.unlockedExpansionNeedsFence(up)) {
                    var nLeft = utilGrid.getExpansionNeighboursNamed(up, baseSetup).left;
                    if (_this.unlockedExpansionNeedsFence(nLeft)) {
                        _this.addGraphic(getPillarIso, IdOrientation.Left);
                    }
                }
            }
            if (_this.unlockedExpansionNeedsFence(down)) {
                _this.addGraphic(getPieceIso, IdOrientation.Down);
                if (!_this.unlockedExpansionNeedsFence(right)) {
                    var nDown = utilGrid.getExpansionNeighboursNamed(right, baseSetup).down;
                    if (_this.unlockedExpansionNeedsFence(nDown)) {
                        _this.addGraphic(getPillarIso, IdOrientation.Down);
                    }
                }
            }
        };
        _this.addCornerPillars = function (neighbours, checkFn) {
            var getCornerPillarIso = _this.props.getCornerPillarIso;
            var up = neighbours.up, down = neighbours.down, left = neighbours.left, right = neighbours.right;
            if (checkFn(up) && checkFn(right)) {
                _this.addGraphic(getCornerPillarIso, IdOrientation.Up);
            }
            if (checkFn(down) && checkFn(left)) {
                _this.addGraphic(getCornerPillarIso, IdOrientation.Down);
            }
            if (checkFn(up) && checkFn(left)) {
                _this.addGraphic(getCornerPillarIso, IdOrientation.Left);
            }
            if (checkFn(down) && checkFn(right)) {
                _this.addGraphic(getCornerPillarIso, IdOrientation.Right);
            }
        };
        _this.addGraphic = function (getGraphicFn, orientation) {
            var _a = _this.props, fence = _a.fence, baseSetup = _a.expansionInfo.baseSetup;
            var _b = fence.proto, posX = _b.posX, posY = _b.posY;
            var graphic = getGraphicFn(fence, orientation, baseSetup);
            if (!graphic) {
                return;
            }
            var expansionPartId = _this.getExpansionPartId(posX || 0, posY || 0, orientation);
            graphic.name = expansionPartId;
            if (!_this.graphicsByExpansionPartId.has(expansionPartId)) {
                _this.graphicsByExpansionPartId.set(expansionPartId, [graphic]);
            }
            else {
                _this.graphicsByExpansionPartId.get(expansionPartId).push(graphic);
            }
        };
        _this.onClick = function (event) {
            var _a = _this.props, onSelect = _a.onSelect, fence = _a.fence, buildingPlacement = _a.buildingPlacement;
            var offset = utilGrid.mapToScreen(7, 1);
            var center = new Point(event.currentTarget.x + offset.x, event.currentTarget.y + offset.y);
            if (buildingPlacement &&
                (buildingPlacement.action === TypeBuildingAction.Move ||
                    buildingPlacement.action === TypeBuildingAction.Construct)) {
                return;
            }
            var mapPos = utilGrid.screenToMap(center.x, center.y);
            fence.proto.posX = mapPos.x;
            fence.proto.posY = mapPos.y;
            onSelect(fence, center);
        };
        _this.unlockedExpansionNeedsFence = function (id) {
            var unlockedExpansionIds = _this.props.expansionInfo.unlockedExpansionIds;
            if (!unlockedExpansionIds) {
                return false;
            }
            return id == undefined || unlockedExpansionIds.indexOf(id) === -1;
        };
        _this.lockedExpansionNeedsFence = function (id) {
            var unlockedExpansionIds = _this.props.expansionInfo.unlockedExpansionIds;
            if (!unlockedExpansionIds || id == undefined) {
                return false;
            }
            return unlockedExpansionIds.indexOf(id) !== -1;
        };
        _this.getExpansionPartId = function (x, y, orientation) {
            return x + "_" + y + "_" + orientation;
        };
        _this.getExpansionPartInfoById = function (partId) {
            var baseSetup = _this.props.expansionInfo.baseSetup;
            var idParts = partId.split("_");
            var x = parseInt(idParts[0], 10);
            var y = parseInt(idParts[1], 10);
            var orientation = idParts[2];
            var id = utilGrid.XYToExpansionId(x, y, baseSetup);
            return {
                id: id,
                orientation: orientation,
                x: x,
                y: y,
            };
        };
        _this.addHighlight = function (event) {
            _this.changeFilters(event.currentTarget, [new OutlineFilter(2, 0xffffff)]);
        };
        _this.removeHighlight = function (event) {
            // tslint:disable-next-line:no-null-keyword
            _this.changeFilters(event.currentTarget, null);
        };
        _this.changeFilters = function (display, filters) {
            if (display !== undefined) {
                var cache = display.cacheAsBitmap;
                display.cacheAsBitmap = false;
                display.filters = filters;
                display.cacheAsBitmap = cache;
            }
        };
        return _this;
    }
    LayerPlayerBaseSurrounding.prototype.destroy = function (options) {
        _super.prototype.destroy.call(this, options);
        this.clickSub$.unsubscribe();
        this.mouseOverSub$.unsubscribe();
        this.mouseOutSub$.unsubscribe();
    };
    return LayerPlayerBaseSurrounding;
}(SceneLayer));
export { LayerPlayerBaseSurrounding };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/layers/LayerPlayerBaseSurrounding.ts
// module id = 868
// module chunks = 3